export const blockIconsHomeFamiliarFaceAndZoneNew = (
	<span className='material-symbols-outlined'>familiar_face_and_zone</span>
);
